import { Provider } from '@angular/core';
import { MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';

// Accepted when typing/pasting into a datepicker input; tried in order until one parses.
const DATE_PARSE_FORMATS = ['dd/MM/yyyy', 'd/M/yyyy', 'dd-MM-yyyy', 'd-M-yyyy', 'yyyy-MM-dd'];

const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: DATE_PARSE_FORMATS,
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'LLL yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'LLLL yyyy',
  },
};

/**
 * Luxon-based date adapter accepting multiple pasted date formats (dd/MM/yyyy, d/M/yyyy,
 * dd-MM-yyyy, yyyy-MM-dd) instead of only the exact format produced by the native Intl parser,
 * which rejected valid pasted dates that didn't match navigator.language's format exactly.
 */
export function provideAppDateAdapter(): Provider[] {
  return [
    provideLuxonDateAdapter(APP_DATE_FORMATS),
    { provide: MAT_DATE_LOCALE, useValue: navigator.language },
  ];
}
